import Component from '@glimmer/component';

export default class PageHeadersPrimaryActionsComponent extends Component {
  get primaryActionSelector() {
    return document.querySelector('#primary-actions');
  }
}
